import {CurrencyRepo} from "../api/currency.repo";
import {inject, Injectable} from "@angular/core";
import {OrgDto} from "../dto/org.dto";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {CurrencyDto} from "../dto/currency.dto";
import {DuckDbHelper} from "./duckdb.helper";
import {OrgDuckDb} from "./org.duckdb";
import {map} from "rxjs/operators";
import {isDefined} from "../../libs/utils/epic.utils";

@Injectable({providedIn: 'root'})
export class CurrencyDuckDb extends CurrencyRepo {

  private readonly orgRepo = inject(OrgDuckDb);
  private currency: CurrencyDto | undefined;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override readAll(_org: OrgDto): Observable<WrapperDto<CurrencyDto>> {
    return DuckDbHelper.datasObs('CurrencyDto', this.buildCurrencies());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override readCurrent(_org: OrgDto): Observable<WrapperDto<CurrencyDto>> {
    if (isDefined(this.currency)) {
      return DuckDbHelper.dataObs('CurrencyDto', this.currency);
    }
    return this.orgRepo.readById('').pipe(map((res) => {
      const org = res.getFirstData();
      this.currency = this.buildCurrencies().find((c) => c.code === org.defaultCurrency.code);
      return DuckDbHelper.data('CurrencyDto', this.currency!);
    }));
  }

  private buildCurrencies(): CurrencyDto[] {
    return [
      new CurrencyDto({code: 'CHF', symbol: 'CHF', html: 'CHF'}),
      new CurrencyDto({code: 'EUR', symbol: '€', html: '&euro;'}),
      new CurrencyDto({code: 'GEL', symbol: '₾', html: '&#x20BE;'}),
      new CurrencyDto({code: 'USD', symbol: '$', html: '&dollar;'}),
    ];
  }
}
